import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AbilityService } from '../../../_shared/services/ability.service';
import { UtilService } from '../../../_shared/services/util.service';

import { LanguageService } from '../../../languages/shared/language.service';

import { OccupancyType } from '../../shared/occupancy-type.model';
import { OccupancyTypeService } from '../../shared/occupancy-type.service';
import { OccupancyTypeListComponent } from '../../occupancy-type-list/occupancy-type-list.component';
import { OccupancyTypeDetailComponent } from '../../occupancy-type-detail/occupancy-type-detail.component';

@Component({
  selector: 'app-occupancy-types-modal',
  templateUrl: './occupancy-types-modal.component.html',
  standalone: true,
  imports: [SharedModule, OccupancyTypeListComponent, OccupancyTypeDetailComponent],
})
export class OccupancyTypesModalComponent {
  constructor(
    private occupancyTypeService: OccupancyTypeService,
    private languageService: LanguageService,
    private abilityService: AbilityService,
    private utilService: UtilService,
    private ref: MatDialogRef<OccupancyTypesModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getAdditionalLanguages();
  }

  modalTitle = this.data.title;

  occupancyTypes: OccupancyType[];
  meta = [];
  occupancyType: OccupancyType;
  mode = '';
  loadingOccupancyTypes = false;

  listMode = true;
  detailMode = false;

  permissions = {
    canList: this.abilityService.can('index_occupancytype_accountadmin'),
    canCreate: this.abilityService.can('create_occupancytype_accountadmin'),
  };

  defaultLanguage: any;
  additionalLanguages = [];

  private filterCriteria = this.occupancyTypeService.getFilterCriteria();

  showOccupancyTypes() {
    this.modalTitle = this.data.title;

    this.listMode = true;
    this.detailMode = false;

    this.getOccupancyTypes();
  }

  addOccupancyType() {
    this.modalTitle = 'ADD_OCCUPANCY_TYPE';
    this.listMode = false;
    this.detailMode = true;

    this.occupancyType = {};
  }

  // Referenced from app-occupancy-type-detail
  onSavedOccupancyType(occupancyType) {
    this.occupancyType = occupancyType;

    this.listMode = true;
    this.detailMode = false;

    this.getOccupancyTypes(occupancyType);
  }

  // Referenced from app-occupancy-type-detail
  onCanceledOccupancyType() {
    this.showOccupancyTypes();
  }

  close() {
    this.ref.close(true);
  }

  // Referenced from app-occupancy-type-list
  onSelectedOccupancyType({ occupancyType, mode = '' }) {
    this.occupancyType = occupancyType;
    this.mode = mode;

    this.modalTitle = 'OCCUPANCY_TYPE_DETAILS';
    this.listMode = false;
    this.detailMode = true;
  }

  private getOccupancyTypes(selectedOccupancyType = null) {
    this.filterCriteria.lang = this.defaultLanguage.lang;
    // this.filterCriteria['skip_check_role'] = true;

    this.loadingOccupancyTypes = true;
    this.occupancyTypeService.getOccupancyTypes(this.filterCriteria).subscribe((response) => {
      this.occupancyTypes = response.data;
      this.meta = response.meta;

      this.loadingOccupancyTypes = false;

      if (selectedOccupancyType) {
        this.utilService.changeItemRowStyle(selectedOccupancyType.id);
      }
    });
  }

  private getAdditionalLanguages() {
    this.languageService.getLanguages({ skip_check_role: true }).subscribe((response) => {
      this.defaultLanguage = response.data.find((language) => language.is_default);
      this.additionalLanguages = response.data.filter((language) => !language.is_default);

      this.getOccupancyTypes();
    });
  }
}
